import { AutocompleteElement } from 'react-hook-form-mui';

export default AutocompleteElement;
